import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const WinnerMedalIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 25 48">
        <path d="M24.375 20.2713V0.25H0.625V20.2713C0.625 21.1025 1.0525 21.8863 1.78875 22.3138L11.7163 28.275L9.365 33.8325L1.26625 34.5213L7.4175 39.8413L5.54125 47.75L12.5 43.5463L19.4588 47.75L17.6062 39.8413L23.7575 34.5213L15.6587 33.8325L13.3075 28.275L23.235 22.3138C23.9475 21.8863 24.375 21.1263 24.375 20.2713ZM14.875 24.5463L12.5 25.9713L10.125 24.5463V2.625H14.875V24.5463Z" />
    </SvgIcon>
);

export default WinnerMedalIcon;
